/*
 * 本地环境读取配置 浏览器访问配置环境
 *
 * 1.线上配置方案 （只对公司内局域网生效）
 * 配置地址：http://192.168.1.201:9011/
 *
 * 2.本地配置方案
 * 当前目录创建文件debug_url.js (src/utils/debug_url.js) 输出地址
 * 文件内容示例  export const debug_url = 'http://192.168.1.205'
 */
import store from '@/store/index'
export default function get_debug() {
  let site = ''
  if (process.env.NODE_ENV == 'development' && location.host != 'zhyx.eingdong.com') {
    const last_dev_url = localStorage.getItem('yxdev_config')
    if (last_dev_url) {
      site = last_dev_url
    }
    let use_local = 0
    try {
      const data = require('./debug_url.js')
      if (data.debug_url) {
        site = data.debug_url
        use_local = 1
      }
    } catch (e) {
      // console.log(e)
    }
    if (!use_local) {
      // 以下异步操作 可能需要从新刷新才会生效
      fetch('http://192.168.1.201:9011/index.php/debug/config/agent').then((res) => {
        return res.text()
      }).then(res => {
        console.error(site, 1, res)
        if (site != res) {
          localStorage.setItem('yxdev_config', res)
          store.commit('change_debug_url', res)
        }
      })
    }
  }
  return site
}
